import React, { useEffect, useState, useRef } from "react";
import { Badge } from "react-bootstrap";

const CountdownTimer = React.memo(({ initialSeconds }) => {
  const [timeLeft, setTimeLeft] = useState(initialSeconds);
  const intervalRef = useRef(null);

  // Restart timer when props change
  useEffect(() => {
    // clear any existing interval
    if (intervalRef.current) clearInterval(intervalRef.current);

    setTimeLeft(initialSeconds);

    if (initialSeconds > 0) {
      intervalRef.current = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(intervalRef?.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [initialSeconds]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  return (
    <p>
        OTP will expire in: 
        <small className="text-white rounded-pill bg-danger m-2 px-2" >
        {formatTime(timeLeft)}
        </small>
        minutes
    </p>

  );
});

export default CountdownTimer;